import React, { useEffect, useRef, useState } from "react";
import { Button } from "../Button/Button";
import { HeroInternas } from "../heroInternas/HeroInternas";

export const InformacionGeneral = () => {
    const [docs, setDocs] = useState([]);
    useEffect(() => {
        fetch("/docs")
            .then(res => res.json())
            .then(result => {
                let resultados = {};
                result.forEach(element => {
                    const nombre = element.nombre;
                    if (!resultados[nombre]) resultados[nombre] = [];
                    resultados[nombre].push(element);
                });

                if (result.estado === undefined) {
                    setDocs(Object.entries(resultados));
                } else {
                    if (result.estado !== 0) {
                        setDocs(result);
                    }
                }
            });
    }, []);

    return (
        <>
            <HeroInternas
                title="Información"
                title2="general"
                clase="info"
                img="/images/internas/info-desktop.png"
                imgMobile="/images/internas/info-mobile.png"
            />
            <div>
                <div className="infoGeneral bg-gris">
                    <div className="infoGeneral--container">
                        {docs.map((entry, idx) => {
                            return (
                                <>
                                    <div
                                        className="infoGeneral--div"
                                        key={entry[0]}
                                    >
                                        <h1>{entry[0]}</h1>
                                        <div className="infoGeneral--div--innerDiv">
                                            {entry[1].map((item, indice) => (
                                                <Button
                                                    key={indice}
                                                    className="btn-info-general"
                                                    pdf={`/api/download_documentacion_externo/${item.id}`}
                                                    img="/images/icons/download.svg"
                                                    imgHover="/images/icons/download-vino.svg"
                                                    text={item.nombre_archivo}
                                                />
                                            ))}
                                            {entry[0] === "Estado de Plan" && (
                                                <>
                                                    <Button
                                                        className="btn-info-general-light"
                                                        link="informacion_general/grupos_finalizados"
                                                        imgHover="/images/icons/plus.svg"
                                                        img="/images/icons/plus-vino.svg"
                                                        text="Grupos finalizados en el período"
                                                    />
                                                    <Button
                                                        className="btn-info-general-light"
                                                        link="informacion_general/puesta_disposicion"
                                                        imgHover="/images/icons/plus.svg"
                                                        img="/images/icons/plus-vino.svg"
                                                        text="Puesta a disposicion de fondos"
                                                    />
                                                </>
                                            )}
                                        </div>
                                        <div className="separator--hor my-half mb-octa"></div>
                                    </div>
                                </>
                            );
                        })}
                        {!docs.some(entry => entry[0] === "Estado de Plan") && (
                            <>
                                <div className="infoGeneral--div">
                                    <h1>Estado de Plan</h1>
                                    <div className="infoGeneral--div--innerDiv">
                                        <Button
                                            className="btn-info-general-light"
                                            link="informacion_general/grupos_finalizados"
                                            imgHover="/images/icons/plus.svg"
                                            img="/images/icons/plus-vino.svg"
                                            text="Grupos finalizados en el período"
                                        />
                                        <Button
                                            className="btn-info-general-light"
                                            link="informacion_general/puesta_disposicion"
                                            imgHover="/images/icons/plus.svg"
                                            img="/images/icons/plus-vino.svg"
                                            text="Puesta a disposicion de fondos"
                                        />
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};
